/**
 *  无需验证即可访问的路由，此路由会router实例化时注册
 *  同时也不会加入到菜单中进行显示
 *  @return { Object } 路由对象
 */
// 登录后的默认访问页面
const INDEX_PATH = '/homepage';

export default [
    {
        path: '/',
        redirect: { path: INDEX_PATH },
    },
    {
        name: 'Login',
        path: '/login',
        component: () => import(/* webpackChunkName: 'login' */ '@/views/login/index.vue'),
    },
    {
        name: 'ElementDemo',
        path: '/elementDemo',
        component: () => import(/* webpackChunkName: 'elementDemo' */ '@/components/ElementDemo.vue'),
    },
    // {
    //     name: 'AntdvDemo',
    //     path: '/antdvDemo',
    //     component: () => import(/* webpackChunkName: 'AntdvDemo' */ '@/components/AntdvDemo.vue'),
    // },
    {
        name: '404',
        path: '/404',
        component: () => import(/* webpackChunkName: '404' */ '@/views/404.vue'),
    },
];
